import React, { Component, Fragment, useEffect } from 'react'
import styled from 'react-emotion'
import moment from 'moment'
// import getText from '../strings'
import { colors } from '../../styles'
import { Svg } from '../../application'

const Row = styled('div')`
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  ${({ fromTui }) =>
    fromTui &&
    `
    align-items: flex-start;
  `}
`

const Message = styled('div')`
  max-width: 90%;

  @media (min-width: 768px) {
    max-width: 40%;
  }
`

const Timestamp = styled('div')`
  color: ${colors.tui_grey};
  font-size: 0.8em;
  padding: 6px 12px;
`

const MessageBubble = styled('div')`
  position: relative;
  background-color: ${colors.tui_white};
  border: 1px solid ${colors.tui_grey_50};
  padding: 12px;
  border-radius: 12px;
  margin: 0 0 12px;

  &::before {
    right: 20px;
    bottom: -14px;
    border: 7px solid;
    border-color: ${colors.tui_grey_50} ${colors.tui_grey_50} transparent
      transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
  }

  &::after {
    right: 21px;
    bottom: -12px;
    border: 6px solid;
    border-color: #fff #fff transparent transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
  }

  ${({ fromTui }) =>
    fromTui &&
    `
      background-color: ${colors.tui_blue_25};
      border-color: ${colors.tui_blue_100};

      &::before {
        left: 20px;
        border-color: ${colors.tui_blue_100} transparent transparent
          ${colors.tui_blue_100};
      }

      &::after {
        left: 21px;
        border-color: ${colors.tui_blue_25} transparent transparent ${colors.tui_blue_25};
      }
    `};
`

const TuiLogo = styled('div')`
  margin: 6px 0 0 0;

  > svg {
    height: 30px;
    width: 30px;
  }
`

const getDateTime = (source) => {
  return moment(source).format('D MMMM YYYY HH:mm:ss')
}

export default ({ message }) => {
  const { timestamp, text, fromTui } = message

  return (
    <Fragment>
      <Row fromTui={fromTui}>
        <Message>
          <Timestamp>{getDateTime(timestamp)}</Timestamp>
          <MessageBubble fromTui={fromTui}>{text}</MessageBubble>
          {fromTui && (
            <TuiLogo>
              <Svg icon="tui-smile" />
            </TuiLogo>
          )}
        </Message>
      </Row>
    </Fragment>
  )
}
